export const module = {
  info: {
    name: 'voip-test-automation-no-actions',
    caption: 'Automation Test No Action',
    viewGroup: 'testing-tools'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Automated No LCR',
    icon: 'el-icon-refresh',
    children: [
      {
        caption: 'Tests',
        icon: 'el-icon-refresh',
        routeName: 'module->voip-test-automation-no-actions->automation_no_action',
        routeParams: { listPage: 1},
      },
      {
        caption: 'History',
        icon: 'el-icon-s-grid',
        routeName: 'module->voip-test-automation-no-actions->history',
        routeParams: { listPage: 1},
      },
    ]
  }
}

export default module
